import UpdateSupplier from "../../../../components/@users/suppliers/UpdateSupplier";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function SupplierUpdatePage() {

    return (
        <UpdateSupplier 
            routeType={routeTypes.admin}
        />
    )
}       